function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "currentColor",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-100.000000, -124.000000)"
}, React.createElement("g", {
  transform: "translate(100.000000, 111.000000)"
}, React.createElement("g", {
  transform: "translate(0.000000, 13.000000)"
}, React.createElement("path", {
  d: "M7.038298,7.03708 L7.038298,1 C10.372258,1 13.075378,3.70312 13.075378,7.03708 C13.075378,10.37146 10.372258,13.07458 7.038298,13.07458 C4.044118,13.07458 1.612738,11.03422 1.092778,8.0854 L7.038298,7.03708 Z",
  id: "Fill-3"
}), React.createElement("path", {
  d: "M8,7.66840545 L0.122773478,9 C-0.644026335,4.8291642 2.26068703,0.851985774 6.61107958,0.116301126 C7.0506818,0.042145821 7.55372028,0 8,0 L8,7.66840545 Z",
  id: "Fill-1"
})))));

var SvgIndexProjects = function SvgIndexProjects(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIndexProjects, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IndexProjects.d46e5040.svg";
export { ForwardRef as ReactComponent };